import React, { Component } from 'react'
import { compose, graphql } from 'react-apollo'
import Radium, { keyframes } from 'radium'
import { Constants } from '@sukiai/components'
import {
  SET_AGENT_SIZE,
  SET_AGENT_POSITION
} from '../../apollo/actions'
import {
  INTRO_TUTORIAL_VIDEO_TITLE_GREETING,
  INTRO_TUTORIAL_VIDEO_DESC,
  SKIP
} from './constants'
import {
  SkipButton,
  PlayButtonIcon,
  PlayButtonContainer
} from './styled'
import VideoPlayer from './videoPlayer'
import { getOobeFile } from '../../lib'

const { AGENT } = Constants

const typeWriterEffectAnimation = keyframes(
  {
    '0%': { opacity: 0, width: '0px' },
    '25%': { opacity: 0.9, width: '0px' },
    '50%': { width: '50%' },
    '75%': { width: '75%' },
    '100%': { width: '100%' }
  }, 'typeWriterEffectAnimation'
)

const TextAnimation = keyframes(
  {
    '0%': { opacity: 0, marginTop: '4%' },
    '100%': { opacity: 1, marginTop: '3%' }
  }, 'TextAnimation'
)

const ContainerAnimation = keyframes(
  {
    '0%': { top: '40%' },
    '100%': { top: '35%' }
  }, 'ContainerAnimation'
)

const styles = {
  titleGreeting: {
    height: '40px',
    fontSize: '2.25em',
    color: '#2D5E60',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    animationName: typeWriterEffectAnimation,
    animationDuration: '3s',
    animationTimingFunction: 'linear',
    animationDelay: '0',
    animationIterationCount: 1
  },
  additionalText: {
    fontSize: '1.75em',
    color: '#2D5E60',
    animationName: TextAnimation,
    animationDuration: '1s',
    animationTimingFunction: 'linear',
    animationDelay: '1s',
    animationIterationCount: 1,
    animationFillMode: 'forwards',
    overflow: 'hidden',
    width: '70%',
    opacity: 0,
    letterSpacing: '0.5px'
  },
  buttonHover: {
    opacity: 0.85,
    cursor: 'pointer'
  },
  veil: {
    position: 'fixed',
    height: '100vh',
    width: '100vw',
    backgroundColor: 'black',
    opacity: 0.9
  },
  container: {
    height: '70%',
    width: '60%',
    position: 'absolute',
    right: '30px',
    top: '40%',
    animationName: ContainerAnimation,
    animationDuration: '0.5s',
    animationTimingFunction: 'linear',
    animationDelay: '1s',
    animationIterationCount: 1,
    animationFillMode: 'forwards'
  }
}

// This is the intro screen where we show the user an option to see a video
class IntroTutorialVideoScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      shouldVideoPlayerShowAndPlay: false,
      isPlayButtonHovered: false,
      isSkipButtonHovered: false,
      isCloseButtonHovered: false
    }
    this.firstTimePlayClicked = true
  }

  componentWillMount () {
    const {
      setAgentSize,
      setAgentPosition
    } = this.props

    setAgentSize(AGENT.SIZE.LARGE)
    setAgentPosition(AGENT.POSITION.MIDDLE_LEFT)
  }

  handlePlayClick = isPlayerVisible => {
    this.setState({ shouldVideoPlayerShowAndPlay: isPlayerVisible })
  }

  handleSkipClicked = () => {
    // Go to home screen
    this.props.parentCallback()
  }

  render () {
    const {
      isPlayButtonHovered,
      isSkipButtonHovered,
      shouldVideoPlayerShowAndPlay
    } = this.state

    const videoFile = getOobeFile()

    return (
      <div>
        <VideoPlayer
          auxCallback={this.props.videoStateCallback}
          isPlayerVisible={shouldVideoPlayerShowAndPlay}
          onPlayerClose={() => this.handlePlayClick(false)}
          videoURL={`https://storage.googleapis.com/oobe-videos/${videoFile}`}
          handleClosedButton={() => this.handleSkipClicked()}
        />
        <div style={styles.container}>
          <div data-cy='oobe-video-screen-title' style={styles.titleGreeting}>{INTRO_TUTORIAL_VIDEO_TITLE_GREETING}</div>
          <div style={styles.additionalText}>
            <div data-cy='oobe-video-screen-additional-text'>{INTRO_TUTORIAL_VIDEO_DESC}</div>
            <PlayButtonContainer>
              <PlayButtonIcon
                onClick={() => this.handlePlayClick(true)}
                style={isPlayButtonHovered ? styles.buttonHover : null}
                onMouseEnter={() => { this.setState({ isPlayButtonHovered: true }) }}
                onMouseLeave={() => { this.setState({ isPlayButtonHovered: false }) }}
                data-cy='oobe-video-screen-play-button'
              />
            </PlayButtonContainer>
          </div>
          <SkipButton
            onClick={this.handleSkipClicked}
            style={isSkipButtonHovered ? styles.buttonHover : null}
            onMouseEnter={() => { this.setState({ isSkipButtonHovered: true }) }}
            onMouseLeave={() => { this.setState({ isSkipButtonHovered: false }) }}
            isvisible={shouldVideoPlayerShowAndPlay ? 'true' : 'false'}
            data-cy='oobe-video-screen-skip-button'
          >
            {SKIP}
          </SkipButton>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  })
)(Radium(IntroTutorialVideoScreen))
